import axios from 'axios';
import { env } from '../env'

export const checkForm = async (provider, identity) => {
    log(`Api.checkForm`);
    if (identity && identity !== null && identity !== '') {
        return await get(`${provider.url}/api/v1.0/forms/check?cfk=${encodeURIComponent(provider.key)}&identity=${identity}`);
    } else {
        return { status: 400 };
    }
};

export const submitForm = async (provider, saveRequest) => {
    log(`Api.submitForm`);
    return await post(`${provider.url}/api/v1.0/forms/submit?cfk=${encodeURIComponent(provider.key)}`, saveRequest)
}

export const get = async (url, isExternal = false) => {
    log(`Api.get`);

    const config = getConfig();
    return await axios.get(url, !isExternal ? config : null)
        .then(function (response) {
            log(response);

            return response;
        })
        .catch(function (error) {
            return handleError(error);
        });
}

export const post = async (url, payload, isExternal = false) => {
    log(`Api.post`);

    const config = getConfig();

    return await axios.post(url, payload, !isExternal ? config : null)
        .then(function (response) {
            log(response);
            return response;
        })
        .catch(function (error) {
            return handleError(error);
        });
}

const handleError = (error) => {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);

        return error.response;
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
    }

    return { status: 400 };
}

const log = (message) => {
    if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
        console.log(message);
    }
}

const getConfig = () => {
    const config = {
        headers: { "x-cpa-client": env.VITE_CLIENT }
    };

    return config; 
};